const getCheckedValues = (question, option) => {
  const findValues = question?.answer?.options.findIndex(ansOpt => ansOpt.id === option.id) >= 0
  return findValues
}

export {getCheckedValues}